import './IntegratedAppsView.scss';
import { AddApp } from './add-app/AddApp';
import { AppMonitorsList } from './app-monitors';
import { AsyncStateNotification } from '@ui/notifications';
import { createAsyncSelectors } from '@lib/selectors';
import { IntegratedApps } from './IntegratedApps';
import React from 'react';
import { BASE_ROUTES, COPY_GENERIC, FULL_ROUTES, PARAMS } from '@sonar-software/sonar-ts-constants';
import { FullUserBoundary, ViewArea } from '@ui/general';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
const postAppMonitorSelectors = createAsyncSelectors((state) => state.core.dataSecurity.monitors.post);
export const IntegratedAppsView = () => {
    const location = useLocation();
    return (React.createElement(React.Fragment, null,
        React.createElement(ViewArea, { className: 'add-app-view-area', collapseSidebar: true, direction: 'horizontal', fullWidth: true, id: 'data-security' },
            React.createElement(Routes, null,
                React.createElement(Route, { element: React.createElement(IntegratedApps, null), path: '' }),
                React.createElement(Route, { element: React.createElement(FullUserBoundary, { redirect: FULL_ROUTES.DATA_SECURITY_APPLICATION_SETUP },
                        React.createElement(AddApp, null)), path: BASE_ROUTES.ADD_APP }),
                React.createElement(Route, { element: React.createElement(AppMonitorsList, { key: location.pathname }), path: PARAMS.ID }),
                React.createElement(Route, { element: React.createElement(Navigate, { to: FULL_ROUTES.DATA_SECURITY }), path: '*' }))),
        React.createElement(AsyncStateNotification, { errored: COPY_GENERIC.CONTACT_SUPPORT, failed: COPY_GENERIC.CONTACT_SUPPORT, stateSelector: postAppMonitorSelectors.state })));
};
